"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accountBulkSuccess = exports.accountBulkSoftDelete = exports.accountBulkRestore = exports.accountBulkReset = exports.accountBulkHardDelete = exports.accountBulkError = exports.accountBulkEnable = exports.accountBulkDisable = exports.accountBulkClean = void 0;
var _accountBulk = require("./accountBulk.constant");
// @flow

// common success
var accountBulkSuccess = function accountBulkSuccess(actionType, data) {
  return {
    type: _accountBulk.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.accountBulkSuccess = accountBulkSuccess;
var accountBulkError = function accountBulkError(actionType, error) {
  return {
    type: _accountBulk.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * account bulk enable
 * @param payload
 * @returns api response
 * @description this function used to enable account of given id's.
 */
exports.accountBulkError = accountBulkError;
var accountBulkEnable = function accountBulkEnable(data) {
  return {
    type: _accountBulk.actionTypes.ENABLE,
    payload: data
  };
};

/**
 * account bulk disable
 * @param payload
 * @returns api response
 * @description this function used to disable account of given id's.
 */
exports.accountBulkEnable = accountBulkEnable;
var accountBulkDisable = function accountBulkDisable(data) {
  return {
    type: _accountBulk.actionTypes.DISABLE,
    payload: data
  };
};

/**
 * account bulk soft delete
 * @param payload
 * @returns api response
 * @description this function used to soft delete account of given id's.
 */
exports.accountBulkDisable = accountBulkDisable;
var accountBulkSoftDelete = function accountBulkSoftDelete(data) {
  return {
    type: _accountBulk.actionTypes.SOFT_DELETE,
    payload: data
  };
};

/**
 * account bulk restore soft deleted
 * @param payload
 * @returns api response
 * @description this function used to restore soft deleted account of given id's.
 */
exports.accountBulkSoftDelete = accountBulkSoftDelete;
var accountBulkRestore = function accountBulkRestore(data) {
  return {
    type: _accountBulk.actionTypes.RESTORE,
    payload: data
  };
};

/**
 * account bulk hard delete
 * @param payload
 * @returns api response
 * @description this function used to hard delete account of given id's.
 */
exports.accountBulkRestore = accountBulkRestore;
var accountBulkHardDelete = function accountBulkHardDelete(data) {
  return {
    type: _accountBulk.actionTypes.HARD_DELETE,
    payload: data
  };
};

/**
 * account bulk clean
 * @param payload
 * @returns api response
 * @description this function used to bulk clean account of given id's.
 */
exports.accountBulkHardDelete = accountBulkHardDelete;
var accountBulkClean = function accountBulkClean(data) {
  return {
    type: _accountBulk.actionTypes.CLEAN,
    payload: data
  };
};

/**
 * account bulk reset
 * @param payload
 * @returns api response
 * @description this function used to reset account of data.
 */
exports.accountBulkClean = accountBulkClean;
var accountBulkReset = function accountBulkReset() {
  return {
    type: _accountBulk.actionTypes.RESET
  };
};
exports.accountBulkReset = accountBulkReset;